var map = {
	"./services1.jpg": "./src/assets/Services/services1.jpg",
	"./services2.jpg": "./src/assets/Services/services2.jpg",
	"./services3.jpg": "./src/assets/Services/services3.jpg",
	"./services4.jpeg": "./src/assets/Services/services4.jpeg",
	"./services5.jpg": "./src/assets/Services/services5.jpg",
	"./services6.jpg": "./src/assets/Services/services6.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/Services sync recursive ^\\.\\/.*$";